import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "components/Common/DeleteModal"
import { usePagination } from "hooks/usePagination"
import ResultHandler from "components/ResultHandler"
import PaginationHandler from "components/PaginationHandler"
import TableHeaderHandler from "components/TableHeaderHandler"
import { PERMISSIONS } from "api/permissions"
import { useTranslation } from "react-i18next"
import { useResponse } from "hooks/useResponse"
import TableAction from "components/TableAction"
import EmptyData from "components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { deleteCreator, getCreators } from "api/creators"
import CustomImage from "components/CustomImage"

export default function CreatorsTable() {
  const { t } = useTranslation()
  const navigate = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
  } = usePagination(getCreators)

  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingCreator, setDeletingCreator] = useState(null)

  const { setData } = useResponse(deleteCreator, () => {
    setShow(false)
    setDeletingCreator(null)
    setPayload({})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingCreator })
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.CREATOR_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl="/add-creator"
      />
      <div className="table-rep-plugin">

        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th style={{ width: "5%" }}>{t("forms.Image")}</Th>
                <Th style={{ width: "65%" }}>{t("forms.Name")}</Th>
                <Th style={{ width: "30%" }}>
                  {t("tables.Action")}
                </Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.creators.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        {row.image_url ? (
                          <CustomImage
                            src={row.image_url}
                            className="rounded avatar-sm"
                            alt=""
                          />
                        ) : (
                          <div className="avatar-sm">
                            <span className="avatar-title rounded bg-primary text-white font-size-16">
                              {row.name.charAt(0)}
                            </span>
                          </div>
                        )}
                      </Td>
                      <Td>
                        {row.name}
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          hasVersions={false}
                          editPermission={PERMISSIONS.CREATOR_EDIT}
                          deletePermission={PERMISSIONS.CREATOR_DELETE}
                          type="creator"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingCreator}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.creators.length === 0}
              msg="No Creators Found."
            />
          )}

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  )
}
